import ApiService from '@/services/api';
import moment from "moment";
import { Storage } from 'aws-amplify';

const API = new ApiService();

export const state = {
  business: null
}

export const mutations = {
  SET_BUSINESS(state, business){
    state.business = business;
  }
}

export const getters = {
}

export const actions = {
  // eslint-disable-next-line no-unused-vars
  createOrganization({ commit }, business) {
    return new Promise((resolve, reject) => {
      API.post('/organization', business)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  fetchOrganization({ commit }, businessId) {
    return new Promise((resolve, reject) => {
      API.get('/organization', { businessId: businessId})
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  },

  // eslint-disable-next-line no-unused-vars
  uploadBusinessLogo({ commit }, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        level: 'public',
        expires: moment().add(365, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      
      Storage.put(`business-logos/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  }
}